// Module
var code = `<div class="js-radio-button {{.additionalClass}}" on-click='radioBtnClick'>
    <div class="js-radio"
         name="{{#.linkGroupName}}{{.}}{{/}}"
         ischecked="{{.checked?'1':'0'}}"
         {{>visualparameters}}>

        <div class="radio-inner-circle-container">
            <div class="radio-inner-circle"></div>
        </div>
    </div>

    {{#if .text}}
    <div class="js-tercera-label" {{^.visible}}style="display:none;"{{/}} {{^.enabled}}disabled=""{{/}}>{{.text}}</div>
    {{/if}}
</div>`;
// Exports
export default code;